import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as restaurantService from "../../services/restaurant.services";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";

const ViewEnrollments = (props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const params = useParams();
    // const [query] = useSearchParams();
    const [showdefault, setShowDefault] = useState({});


    useEffect(() => {   
        restaurantService
            .RestEnrollList({ restaurant_id: params.id })
            .then((response) => {
                setShowDefault(response && response.data && response.data.list ? response?.data?.list[0] : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    const remainingDays = (data) => {
        if (!data) return null;

        // Convert float → integer (always straight value)
        const days = Math.max(0, Math.floor(Number(data.days_in_expiry)));

        if (days <= 5) {
            return (
            <>
                {days}
                {t("admin.cafes.input_value_days")}{" "}
                <span
                className="badge badge-primary cp"
                onClick={() =>
                    navigate(
                    `/admin/cafe-management/cafe/view/${data.restaurant_id}/enroll-cafe/renew-plan`
                    )
                }
                >
                {t("admin.cafes.btn_renew")}
                </span>
            </>
            );
        }

        return days;
    };  


    return (
        <>
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="">
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>
                                                <tr>
                                                    <th>{t("admin.cafes.label_trading_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.restaurent_info[0].cafe_name

                                                            ? showdefault.restaurent_info[0].cafe_name
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_email")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.restaurent_info[0].email

                                                            ? showdefault.restaurent_info[0].email
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_phone_number")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.phone_number
                                                            ? showdefault.phone_number
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_legal_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.company_name
                                                            ? showdefault.company_name
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("admin.cafes.label_representative_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.representative_name ? showdefault.representative_name : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("admin.cafes.label_contractor_name")}</th>
                                                    <td>
                                                        {showdefault && showdefault.contractor_name
                                                            ? showdefault.contractor_name
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_plan_name")}</th>
                                                    <td>
                                                        {showdefault && showdefault.plan_name
                                                            ? removeSpecialCharacter(capitalizeFirstLetter(showdefault.plan_name))
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.contract_plan_duration_type")}</th>
                                                    <td>
                                                        {showdefault && showdefault.contract_plan_duration_type
                                                            ? showdefault.contract_plan_duration_type
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("admin.cafes.label_expiry_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.expiry_date
                                                            ? formateDate(showdefault.expiry_date)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_days_remaining_expiry")}</th>
                                                    <td>
                                                        {remainingDays(showdefault)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_membership_cost")}</th>
                                                    <td>
                                                        {showdefault && String(showdefault.membership_cost)
                                                            ? `£ ${showdefault.membership_cost}`
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_legal_address")}</th>
                                                    <td>
                                                        {showdefault && showdefault.company_address
                                                            ? capitalizeFirstLetter(showdefault.company_address)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("admin.cafes.label_shipping_address")}</th>
                                                    <td>
                                                        {showdefault && showdefault.shipping_address
                                                            ? capitalizeFirstLetter(showdefault.shipping_address)
                                                            : "N/A"}
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <th>{t("admin.list_heading.list_heading_created_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.createdAt
                                                            ? formateDate(showdefault.createdAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                showdefault.length === 0 ? 
                                <div className="text-center">{t("admin.message.msg_no_records")} </div> 
                                :
                                <Loader />
                            )}
                        </div>

                        <div className="mt-2 back-button mx-0">
                          {showdefault.length === 0 && <button
                                className="btn ripple btn-success mlAction mx-2"
                                type="button"
                                onClick={() =>
                                    navigate(`/admin/cafe-management/cafe/enroll-cafe/${params?.id}`)
                                }
                            >
                                
                                {t("admin.cafes.btn_enroll_cafe")}
                            </button>}  


                            <button
                                className="btn ripple btn-dark"
                                type="button"
                                onClick={() =>
                                    navigate("/admin/cafe-management/cafe/list/1")
                                }
                            >
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("admin.button.btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewEnrollments;
